// AUTO-GENERATED GraphQL Builder for WhatsAppSendLog
import * as Builders from '../';
export class WhatsAppSendLogBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  templateCode(){ return this.add('templateCode'); }
  templateLabel(){ return this.add('templateLabel'); }
  audience(){ return this.add('audience'); }
  body(){ return this.add('body'); }
  recipientsJson(){ return this.add('recipientsJson'); }
  recipientCount(){ return this.add('recipientCount'); }
  sentCount(){ return this.add('sentCount'); }
  status(){ return this.add('status'); }
  instanceId(){ return this.add('instanceId'); }
  sentDate(){ return this.add('sentDate'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }
}
